import { useContext } from 'react';
import { SecondaryButton } from '@/common/Button';
import ModalContext from '~/context/vdp/ModalContext';
import { Title, Wrapper } from './CoApplicant.styles';

const WithoutCoApplicant = () => {
  const { setAddCoApplicantModalOpen } = useContext(ModalContext);

  return (
    <Wrapper isDefault data-qa="without-co-applicant">
      <div className="flex flex-col gap-8">
        <Title isDefault>Co-signer</Title>
        <p className="tl-body-m">
          Adding a co-signer can reduce your minimum cash down.
        </p>
      </div>
      <SecondaryButton
        className="!h-40 !min-h-40 !w-full flex-shrink-0 !p-lg min-[450px]:!w-auto"
        onClick={() => setAddCoApplicantModalOpen(true)}
        data-analytics-id="Price Details - Add Co-Signer"
      >
        Add a co-signer
      </SecondaryButton>
    </Wrapper>
  );
};

export default WithoutCoApplicant;
